import script from "./ControllerModelGuideCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ControllerModelGuideCard.vue?vue&type=script&setup=true&lang=js"

import "./ControllerModelGuideCard.vue?vue&type=style&index=0&id=782e9a66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782e9a66"]])

export default __exports__